import PublicEsignaturesCanceledPageTemplate from './pages/esignatures-canceled/esignatures-canceled.page.html';
import PublicEsignaturesSignPageTemplate from './pages/esignatures-sign/esignatures-sign.page.html';
import PublicEsignaturesUnauthorizedPageTemplate from './pages/esignatures-unauthorized/esignatures-unauthorized.page.html';
import PublicEsignaturesSignedPageTemplate from './pages/esignatures-signed/esignatures-signed.page.html';
import PublicEsignaturesExpiredPageTemplate from './pages/esignatures-expired/esignatures-expired.page.html';
import PublicEsignaturesDownPageTemplate from './pages/esignatures-down/esignatures-down.page.html';
import { PreauthTokenErrorEnum } from './data/preauth-token-error-codes';
import { SignatureRequestErrorEnum } from './data/signature-request-error-codes';

export const PublicEsignatureRoutes = function PublicEsignatureRoutes($stateProvider, PAGE_LAYOUT) {
    $stateProvider
        .state('authentication.esignatures', {
            url: '/esignatures',
            abstract: true,
            template: '<ui-view></ui-view>',
            data: {
                layout: PAGE_LAYOUT.NoNavigationFullWidth
            }
        })
        .state('authentication.esignatures.canceled', {
            url: '/canceled',
            template: PublicEsignaturesCanceledPageTemplate,
            controller: 'EsignaturesCanceledController as vm'
        })
        .state('authentication.esignatures.serviceunavailable', {
            url: '/serviceunavailable',
            template: PublicEsignaturesDownPageTemplate,
            controller: 'EsignaturesDownController as vm'
        })
        .state('authentication.esignatures.unauthorized', {
            url: '/unauthorized',
            template: PublicEsignaturesUnauthorizedPageTemplate,
            controller: 'EsignaturesUnauthorizedController as vm'
        })
        .state('authentication.esignatures.expired', {
            url: '/expired',
            template: PublicEsignaturesExpiredPageTemplate,
            controller: 'EsignaturesExpiredController as vm'
        })
        .state('authentication.esignatures.signed', {
            url: '/signed',
            template: PublicEsignaturesSignedPageTemplate,
            controller: 'EsignaturesSignedController as vm'
        })
        .state('authentication.esignatures.sign', {
            url: '/sign?token',
            template: PublicEsignaturesSignPageTemplate,
            controller: 'EsignaturesSignController as vm',
            data: {
                layout: PAGE_LAYOUT.NoNavigationFullWidth
            },
            resolve: {
                onServiceDisabledRedirect: ['FeatureFlags', '$state', function onServiceDisabledRedirect(FeatureFlags, $state) {
                    const serviceFlag = FeatureFlags.retrieveFlag(FeatureFlags.keys.ESignaturesServiceFlag);
                    if (!serviceFlag) {
                        return $state.go('authentication.esignatures.serviceunavailable');
                    }

                    return null;
                }],
                resourceStrings: ['ResourceStringsLoaderService', function getResourceStrings(ResourceStringsLoaderService) {
                    return ResourceStringsLoaderService.loadResourceStrings();
                }],
                authToken: ['PublicEsignaturesApi', '$state', '$stateParams', '$transition$', function authToken(PublicEsignaturesApi, $state, $stateParams, $transition$) {
                    // If we have a token in state params, validate it
                    return PublicEsignaturesApi.validateToken({ Token: $stateParams.token })
                        .then(response => {
                            return response;
                        })
                        .catch(response => {
                            switch (response.data.ErrorCode) {
                                case PreauthTokenErrorEnum.PreAuthTokenInvalid:
                                case PreauthTokenErrorEnum.PreAuthTokenAlreadyUsed:
                                    $transition$.abort();
                                    $transition$.router.stateService.go('authentication.esignatures.unauthorized');
                                    break;
                                case SignatureRequestErrorEnum.SignatureRequestCanceled:
                                    $transition$.abort();
                                    $transition$.router.stateService.go('authentication.esignatures.canceled');
                                    break;
                                case PreauthTokenErrorEnum.PreAuthTokenExpired:
                                default:
                                    $transition$.abort();
                                    $transition$.router.stateService.go('authentication.esignatures.expired');
                                    break;
                            }
                        });
                }],
                documentUrl: ['PublicEsignaturesApi', 'authToken', '$state', '$transition$', function documentUrl(PublicEsignaturesApi, authToken, $state, $transition$) {
                    if (!authToken) {
                        return null;
                    }
                    // If we are from storage and it's expired, this will boot to unauth
                    return PublicEsignaturesApi.getDocumentUrl({
                        token: authToken
                    })
                        .then((obj) => obj.IFrameURL)
                        .catch(response => {
                            switch (response.data.ErrorCode) {
                                case PreauthTokenErrorEnum.PreAuthTokenInvalid:
                                case PreauthTokenErrorEnum.PreAuthTokenAlreadyUsed:
                                    $transition$.abort();
                                    $transition$.router.stateService.go('authentication.esignatures.unauthorized');
                                    break;
                                case SignatureRequestErrorEnum.SignatureRequestCanceled:
                                    $transition$.abort();
                                    $transition$.router.stateService.go('authentication.esignatures.canceled');
                                    break;
                                case PreauthTokenErrorEnum.PreAuthTokenExpired:
                                default:
                                    $transition$.abort();
                                    $transition$.router.stateService.go('authentication.esignatures.expired');
                                    break;
                            }
                        });
                }],
                isUseSignedAtInsteadOfIsSignedEnabled: ['PublicFeatureFlagsService', function isUseSignedAtInsteadOfIsSignedEnabled(PublicFeatureFlagsService) {
                    return PublicFeatureFlagsService.retrieveFlag(PublicFeatureFlagsService.keys.EsignaturesUseSignedAtInsteadOfIsSigned);
                }]
            }
        });
};

PublicEsignatureRoutes.$inject = ['$stateProvider', 'PAGE_LAYOUT'];
